/* eslint-disable fp/no-nil */
/* eslint-disable fp/no-rest-parameters */
/* eslint-disable better/no-ifs */

import { Flag } from './Flag.js'
import flags from './profiles/flags.js'


export default Flag(flags)
